var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 62,
    viewBox: "0 0 78 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.976 22.2616C25.0308 18.8895 28.0526 13.7547 33.774 13.7547C40.863 13.7547 42.5171 17.4717 42.5171 22.2616C42.5171 26.2717 40.1541 29.0505 38.0274 29.8232C36.8781 30.2408 34.4829 31.3828 34.4829 33.8403C34.4829 36.2979 34.4829 38.1725 34.4829 38.8027M22.9041 52.0355H4L13.9247 42.8198C11.3253 39.354 7.23203 29.8544 10.3801 19.1896C15 3.539 29.4469 1.67924 37 2.03896C47.5 2.53904 53.7192 8.1863 57.5 15.039M22.9041 52.0355H35.6644C43.226 52.4294 58.6801 49.0581 60.0034 32.4225C60.5311 25.7894 59.7834 19.0477 57.5 15.039M22.9041 52.0355C25.5822 54.4773 33.5377 59.5027 43.9349 60.0698C54.3322 60.6369 67.6438 60.3061 73 60.0698L59.5 53.039C62.887 50.5972 71.5 44.539 70.5 30.539C69.5738 17.572 62.2774 15.039 57.5 15.039",
    stroke: "white",
    strokeWidth: 2.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 42.0391,
    r: 1,
    fill: "#073161",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.089bb0dacc537d69021c0508699b12bb.svg";
export { ForwardRef as ReactComponent };